// Generated by purs version 0.15.10
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Fusion_LoadIntermediate from "../Fusion.LoadIntermediate/index.js";
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_List_Types.foldableList)(Fusion_Data_Speed.monoidSpeed);
var map = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var length = /* #__PURE__ */ Data_Foldable.length(Data_List_Types.foldableList);
var length1 = /* #__PURE__ */ length(Data_Semiring.semiringNumber);
var length2 = /* #__PURE__ */ length(Data_Semiring.semiringInt);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var isFinal = /* #__PURE__ */ Fusion_Generator.isFinal(/* #__PURE__ */ Fusion_Generator.isFinalEither(Fusion_LoadIntermediate.isFinalLoadOutput));
var groupedAverage = function (dictMonadApp) {
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var form2toForm1 = Fusion_Generator.form2toForm1(MonadAppNE4.ManageAVar3())(MonadAppNE4.MonadFork0())(dictMonadApp.MonadKill3());
    var bracket = Control_Monad_Fork_Class.bracket(dictMonadApp.MonadBracket2());
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var discard1 = discard(Bind1);
    var when = Control_Applicative.when(Applicative0);
    return function (groupSize) {
        return function (mkGen) {
            return form2toForm1(function (emit) {
                return bracket(mkGen)(function (v) {
                    return function (gen) {
                        return Fusion_Generator.cancel(gen);
                    };
                })(function (gen) {
                    var emitGroupAverage = function (v) {
                        if (v instanceof Data_List_Types.Nil) {
                            return pure(Data_Unit.unit);
                        };
                        if (v instanceof Data_List_Types.Cons) {
                            var sumSpeeds = fold(map(function (v1) {
                                return v1.speed;
                            })(v));
                            var size = length1(v);
                            var avg = Fusion_Data_Speed.fromBps(Fusion_Data_Speed.toBps(sumSpeeds) / size);
                            return emit(new Data_Either.Right(new Fusion_LoadIntermediate.TotalIntermediate({
                                speed: avg,
                                timestamp: v.value0.timestamp
                            })));
                        };
                        throw new Error("Failed pattern match at Fusion.GenTransformers (line 36, column 9 - line 36, column 58): " + [ v.constructor.name ]);
                    };
                    var loop = function (group) {
                        return bind(Fusion_Generator.next(gen))(function (v) {
                            return bind((function () {
                                if (v instanceof Data_Either.Right && v.value0 instanceof Fusion_LoadIntermediate.TotalIntermediate) {
                                    var newGroup = new Data_List_Types.Cons(v.value0.value0, group);
                                    var $37 = length2(newGroup) === groupSize;
                                    if ($37) {
                                        return discard1(emitGroupAverage(newGroup))(function () {
                                            return pure(Data_List_Types.Nil.value);
                                        });
                                    };
                                    return pure(newGroup);
                                };
                                return discard1(when(isFinal(v))(emitGroupAverage(group)))(function () {
                                    return discard1(emit(v))(function () {
                                        return pure(group);
                                    });
                                });
                            })())(function (newGroup) {
                                return when(!isFinal(v))(loop(newGroup));
                            });
                        });
                    };
                    return loop(Data_List_Types.Nil.value);
                });
            });
        };
    };
};
export {
    groupedAverage
};
